module.exports = __webpack_public_path__ + "static/media/3d5.5307c94d.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/3d5.png
// module id = 94
// module chunks = 0